import type { DateInputProps as AriaDateInputProps } from 'react-aria-components';
import {
  DateInput as AriaDateInput,
  DateSegment as AriaDateSegment,
} from 'react-aria-components';

import { type SelectSize, sizes } from '@/lib/base/forms/select/select';
import { cx } from '@/utils/cx.ts';

type DateInputProps = Omit<AriaDateInputProps, 'children'> & {
  /**
   * Field size, on the shared field-control scale. Defaults to `'sm'` (40px)
   * — the height this component previously hardcoded.
   */
  size?: SelectSize;
};

export const DateInput = ({ size = 'sm', ...props }: DateInputProps) => {
  return (
    <AriaDateInput
      {...props}
      className={state =>
        cx(
          'flex rounded-lg bg-primary shadow-xs ring-1 ring-primary ring-inset focus-within:ring-2 focus-within:ring-brand',
          sizes[size].root,
          typeof props.className === 'function'
            ? props.className(state)
            : props.className
        )
      }
    >
      {segment => (
        <AriaDateSegment
          segment={segment}
          className={cx(
            'rounded px-0.5 text-primary tabular-nums caret-transparent focus:bg-brand-solid focus:font-medium focus:text-fg-white focus:outline-hidden',
            // The placeholder segment.
            segment.isPlaceholder && 'text-placeholder uppercase',
            // The separator "/" segment.
            segment.type === 'literal' && 'text-fg-quaternary'
          )}
        />
      )}
    </AriaDateInput>
  );
};
